var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14469_42725)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M19.8509 0.386719H8.14776C3.5726 0.386719 0.5 3.59702 0.5 8.37468V19.4001C0.5 24.1765 3.5726 27.3868 8.14776 27.3868H19.8495C24.4247 27.3868 27.5 24.1765 27.5 19.4001V8.37468C27.5 3.59702 24.426 0.386719 19.8509 0.386719Z",
    fill: "#CE2600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.623 11.8477H17.241C16.1325 11.8497 15.2345 12.7252 15.2325 13.8061C15.231 14.8893 16.13 15.7687 17.241 15.7702H19.625V15.9423C19.625 17.8319 18.4795 18.9492 16.541 18.9492H11.4595C9.5205 18.9492 8.375 17.8319 8.375 15.9423V11.8268C8.375 9.93719 9.5205 8.82422 11.4595 8.82422H16.539C18.4775 8.82422 19.623 9.93719 19.623 11.8268V11.8477ZM11.041 11.8433H14.2135H14.2155H14.2195C14.457 11.8424 14.649 11.6537 14.648 11.4216C14.647 11.1901 14.453 11.0029 14.2155 11.0039H11.041C10.805 11.0048 10.6135 11.1915 10.6125 11.4221C10.6115 11.6537 10.8035 11.8424 11.041 11.8433Z",
    fill: "#CE2600"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.271 14.0552C16.3887 14.5902 16.8578 14.9667 17.3933 14.9569H19.2214C19.4443 14.9569 19.625 14.7723 19.625 14.5442V13.1202C19.6245 12.8925 19.4443 12.7075 19.2214 12.707H17.3503C16.7411 12.709 16.249 13.2146 16.25 13.8378C16.25 13.9107 16.2572 13.9837 16.271 14.0552Z",
    fill: "#CE2600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.375 14.3945C17.6857 14.3945 17.9375 14.1427 17.9375 13.832C17.9375 13.5214 17.6857 13.2695 17.375 13.2695C17.0643 13.2695 16.8125 13.5214 16.8125 13.832C16.8125 14.1427 17.0643 14.3945 17.375 14.3945Z",
    fill: "#CE2600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14469_42725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(0.5 0.386719)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.f4cce01f68f4673540cdc2c1c51c7577.svg";
export { ForwardRef as ReactComponent };